<template>
  <section id="content">
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box">
          <div class="box-header">
              <label for="recordPerPage" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
              <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                <select v-on:change="changePageSize" ref="recordPerPage" class="form-control">
                  <option v-if="inquiryParam.pageSize == 5" selected>5</option><option v-else>5</option>
                  <option v-if="inquiryParam.pageSize == 10" selected>10</option><option v-else>10</option>
                  <option v-if="inquiryParam.pageSize == 20" selected>20</option><option v-else>20</option>
                  <option v-if="inquiryParam.pageSize == 50" selected>50</option><option v-else>50</option>
                  <option v-if="inquiryParam.pageSize == 100" selected>100</option><option v-else>100</option>
                </select>
              </div>          
              <div class="box-tools">
                <button class="btn btn-default" data-toggle="modal" data-target="#modal-filter">Filter</button>
                <button v-on:click="inquiry" class="btn btn-warning">Search</button>
                <button v-on:click="onDownload" class="btn btn-primary">Download</button>
              </div>
          </div>        
          <div class="box-body no-padding table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th style="width: 45px;text-align:right;">#</th>
                  <th style="text-align:center;">Action</th>
                  <th style="text-align:left;">Name</th>        
                  <th style="text-align:right;">Total Amount</th>
                  <th style="text-align:center;">Currency</th>
                  <th style="text-align:left;">First Name</th>
                  <th style="text-align:left;">Last Name</th>
                  <th style="text-align:left;">Email</th>
                  <th style="text-align:center;">Process Date</th>               
                  <th style="text-align:center;">Booking Date</th>
                  <th style="text-align:left;">Project</th>  
                  <th style="text-align:center;">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, i) in listData" v-bind:key="i">
                  <td style="width:45px;text-align:right;">{{ startSequence + i + 1}}</td>
                  <td style="width:45px;text-align:center;">
                    <a href="#" v-on:click="onDisplay(row)" ref="displayRow" style="padding-right:5px">
                      <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display"></span>
                    </a>
                  </td>
                  <td style="text-align:left;" nowrap>{{ row.name }}</td>
                  <td style="text-align:right;" nowrap>{{ row.total_amount }}</td>                    
                  <td style="text-align:center;" nowrap>{{ row.currency_name }}</td>
                  <td style="text-align:left;" nowrap>{{ row.first_name }}</td>
                  <td style="text-align:left;" nowrap>{{ row.last_name }}</td>
                  <td style="text-align:left;" nowrap>{{ row.email }}</td>
                  <td style="text-align:center;" nowrap>{{ row.process_date }}</td>
                  <td style="text-align:center;" nowrap>{{ row.booking_date }}</td>
                  <td style="text-align:left;" nowrap>{{ row.project_name }}</td>
                  <td style="text-align:center;">{{ row.status }}
                    <!-- <span v-if="row.status == SESSION_NEW" class="badge bg-blue">{{ row.status }}</span>
                    <span v-if="row.status == SESSION_INPROGRESS" class="badge bg-yellow">{{ row.status }}</span>
                    <span v-if="row.status == SESSION_CLOSED" class="badge bg-green">{{ row.status }}</span> -->
                  </td>
                  <td hidden>{{ row.id }}</td>
                  <td hidden>{{ row.currency_id }}</td>
                  <td hidden>{{ row.project_id }}</td>
                  <td hidden>{{ row.company_id }}</td>                    
                </tr>
              </tbody>
            </table>
          </div>
          <div class="box-footer">
            <div class="form-group">
              <label style="width:25px;text-align:right;">
                  <a href="#"><i v-on:click="changePage(1)" class="icon ion-ios-rewind"></i></a>
              </label>
              <label style="width:35px;text-align:center;">
                  <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
              </label>
              <label>
                  Page
              </label>
              <label>
                  <input v-model="inquiryParam.CurrentPageNumber" v-on:keyup.enter="gotoPage($event)" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
              </label>
              <label id="TotalPageText">
                {{ totalPages }}                
              </label>
              <label style="width:35px;text-align:center;">
                  <a href="#"><i v-on:click="changePage(inquiryParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
              </label>
              <label style="width:25px;text-align:left;">
                  <a href="#"><i v-on:click="changePage(totalPages)" class="icon ion-ios-fastforward"></i></a>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="modal-filter" style="display: none;">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span></button>
            <h4 class="modal-title">Filter</h4>
          </div>
          <div class="modal-body">
            <div class="box-body no-border form-horizontal">
              <div class="form-group">
                <label class="col-md-2 control-label">Order Name</label>
                <div class="col-md-10">
                    <input type="text" id="filterName" v-model="searchParam.name" style="width:100%">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">First Name</label>
                <div class="col-md-10">
                  <input type="text" id="filterFirstName" v-model="searchParam.first_name" style="width:100%">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Last Name</label>
                <div class="col-md-10">
                  <input type="text" id="filterLastName" v-model="searchParam.last_name" style="width:100%">
                </div>                     
              </div>             
              <div class="form-group">
                <label class="col-md-2 control-label">Email</label>
                <div class="col-md-10">
                  <input type="text" id="filterEmail" v-model="searchParam.email" style="width:100%">
                </div>                     
              </div>
              <div class="form-group">
                <label class="col-md-2 control-label">Process Date</label>
                <div class="col-md-10">
                  <div class="input-group">
                    <datepicker v-if="showProcessDateFrom" ref="processDateFrom" :value=searchParam.process_date_from :format=DATE_FORMAT :input-attr="{ 'id': 'filterProcessDateFrom' }" :input-style="{ 'width': '100%' }"></datepicker>
                    <label>to</label>
                    <datepicker v-if="showProcessDateTo" ref="processDateTo" :value=searchParam.process_dateto :format=DATE_FORMAT :input-attr="{ 'id': 'filterProcessDateTo' }" :input-style="{ 'width': '100%' }"></datepicker>
                  </div>
                </div>                     
              </div>               
              <div class="form-group">
                <label class="col-md-2 control-label">Booking Date</label>
                <div class="col-md-10">
                  <div class="input-group">
                    <datepicker v-if="showBookingDateFrom" ref="bookingDateFrom" :value=searchParam.booking_date_from :format=DATE_FORMAT :input-attr="{ 'id': 'filterBookingDateFrom' }" :input-style="{ 'width': '100%' }"></datepicker>
                    <label>to</label>
                    <datepicker v-if="showBookingDateTo" ref="bookingDateTo" :value=searchParam.booking_dateto :format=DATE_FORMAT :input-attr="{ 'id': 'filterBookingDateTo' }" :input-style="{ 'width': '100%' }"></datepicker>
                  </div>
                </div>                     
              </div>                      
              <div class="form-group">
                <label class="col-md-2 control-label">Status</label>
                <div class="col-md-10">
                  <input type="text" id="filteStatus" v-model="searchParam.status" style="width:100%">
                </div>                     
              </div>                                                             
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default pull-left" data-dismiss="modal" ref="btnCloseModal">Close</button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="onApplyFilter($event)">Apply</button>
            <button type="button" class="btn btn-primary" @click="onResetFilter($event)">Reset</button>
          </div>
        </div>
      </div>
    </div>    
  </section>  
</template>

<script>
import $ from 'jquery'
import moment from 'moment'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'

// const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
// const MODE_UPDATE = 'update'
const SESSION_NEW = 'New'
const SESSION_INPROGRESS = 'InProgress'
const SESSION_CLOSED = 'Closed'

export default {
  name: 'PaymentOrder',
  components: {
    datepicker
  },
  data() {
    return {
      DATE_FORMAT: config.dateFormat,
      DATE_FORMAT_SQL: config.dateFormatSql,
      DATETIME_FORMAT_ISO: config.dateTimeFormatSql,
      SESSION_NEW: SESSION_NEW,
      SESSION_INPROGRESS: SESSION_INPROGRESS,
      SESSION_CLOSED: SESSION_CLOSED,
      listData: null,
      totalRows: 0,
      totalPages: 0,
      startSequence: 0,
      inquiryParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'DESC',
        SortExpression: 'process_date',
        WhereClauseByProject: ''
      },
      searchParam: {
        name: '',
        first_name: '',
        last_name: '',
        email: '',
        process_date_from: '',
        process_date_to: '',
        booking_date_from: '',
        booking_date_to: '',
        status: ''
      },
      tabActive: '',
      listProject: null,
      listCashier: null,
      listPOS: null,
      showBookingDateFrom: true,
      showBookingDateTo: true,
      showProcessDateFrom: true,
      showProcessDateTo: true
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {
    this.$refs.recordPerPage.value = this.inquiryParam.PageSize
    this.$root.$on('inquiryPaymentOrderByProject', (projectIds) => {
      this.projectIds = projectIds
      return this.inquiry()
    })
    this.searchParam.status = ''
    this.onApplyFilter()
  },
  methods: {
    changePageSize(evt) {
      this.inquiryParam.PageSize = evt.target.value
      this.inquiryParam.CurrentPageNumber = 1
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    gotoPage(evt) {
      if (evt.target.value > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else if (evt.target.value < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    changePage(page) {
      if (page < 1) {
        this.inquiryParam.CurrentPageNumber = 1
      } else if (page > this.totalPages) {
        this.inquiryParam.CurrentPageNumber = this.totalPages
      } else {
        this.inquiryParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryParam.CurrentPageNumber - 1) * this.inquiryParam.PageSize
      this.inquiry()
    },
    onSearch(evt) {
      // var keyWords = evt.target.value
      // var whereClause = ['Name', 'like', '\'%' + keyWords + '%\'']
      // this.inquiryParam.WhereClause = whereClause.join(' ')
      this.inquiry()
    },
    inquiry() {
      this.inquiryParam.WhereClauseByProject = ''
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'project_id IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }

      api
        .request('Payment', 'get', '/api/Payment/InquiryOrder?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
                                 '&PageSize=' + this.inquiryParam.PageSize + '&CurrentPageNumber=' + this.inquiryParam.CurrentPageNumber +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null)
        .then(response => {
          var data = response.data
          this.listData = data.entity
          this.total = data.totalRows
          this.totalPages = data.totalPages
          this.$refs.recordPerPage.value = this.inquiryParam.PageSize
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onDisplay(row) {
      let params = {
        id: row.id,
        mode: MODE_VIEW,
        callback: this.$route.name
      }

      // this.$route.meta.breadcrumb.push({ name: 'PaymentOrder ', path: '/admin/payment/order/form', meta: { description: 'PaymentOrder' + row.name } })
      // var breadcrumbTemp = this.$route.meta.breadcrumb
      this.$router.push({ name: 'PaymentOrder', params: params })
      // this.$route.meta.breadcrumb = breadcrumbTemp
    },
    onApplyFilter() {
      var filterParams = []

      if (this.searchParam.name !== '') {
        filterParams.push(['name', '=', '\'' + this.searchParam.name + '\''])
      }
      if (this.searchParam.first_name !== '') {
        filterParams.push(['first_name', '=', '\'' + this.searchParam.first_name + '\''])
      }
      if (this.searchParam.last_name !== '') {
        filterParams.push(['last_name', '=', '\'' + this.searchParam.last_name + '\''])
      }
      if (this.searchParam.email !== '') {
        filterParams.push(['email', '=', '\'' + this.searchParam.email + '\''])
      }
      if ($('#filterProcessDateFrom').val() !== '') {
        this.searchParam.process_date_from = $('#filterProcessDateFrom').val()
        var dateFrom = moment(this.searchParam.process_date_from, this.DATE_FORMAT)
        dateFrom = moment(dateFrom).format(this.DATE_FORMAT_ISO) + ' 00:00:00'
        dateFrom = this.convertToUtcTime(dateFrom, this.DATETIME_FORMAT_ISO)
        filterParams.push(['process_date', '>=', '\'' + dateFrom + '\''])
      }
      if ($('#filterProcessDateTo').val() !== '') {
        this.searchParam.process_date_to = $('#filterProcessDateTo').val()
        var dateTo = moment(this.searchParam.process_date_to, this.DATE_FORMAT)
        dateTo = moment(dateTo).format(this.DATE_FORMAT_ISO) + ' 00:00:00'
        dateTo = this.convertToUtcTime(dateTo, this.DATETIME_FORMAT_ISO)
        filterParams.push(['process_date', '<=', '\'' + dateTo + '\''])
      }
      if ($('#filterBookingDateFrom').val() !== '') {
        this.searchParam.booking_date_from = $('#filterBookingDateFrom').val()
        dateFrom = moment(this.searchParam.booking_date_from, this.DATE_FORMAT)
        dateFrom = moment(dateFrom).format(this.DATE_FORMAT_SQL)
        filterParams.push(['booking_date', '>=', '\'' + dateFrom + '\''])
      }
      if ($('#filterBookingDateTo').val() !== '') {
        this.searchParam.booking_date_to = $('#filterBookingDateTo').val()
        dateTo = moment(this.searchParam.booking_date_to, this.DATE_FORMAT)
        dateTo = moment(dateTo).format(this.DATE_FORMAT_SQL)
        filterParams.push(['booking_date', '<=', '\'' + dateTo + '\''])
      }

      if ($('#filterProcessDateFrom').val() === '') {
        this.searchParam.process_date_from = ''
        this.$refs.processDateFrom._data.pickedValue = ''
      }
      if ($('#filterProcessDateTo').val() === '') {
        this.searchParam.process_date_to = ''
        this.$refs.processDateTo._data.pickedValue = ''
      }
      if ($('#filterBookingDateFrom').val() === '') {
        this.searchParam.booking_date_from = ''
        this.$refs.bookingDateFrom._data.pickedValue = ''
      }
      if ($('#filterBookingDateTo').val() === '') {
        this.searchParam.booking_date_to = ''
        this.$refs.bookingDateTo._data.pickedValue = ''
      }

      if (this.searchParam.status !== '') {
        filterParams.push(['status', '=', '\'' + this.searchParam.status + '\''])
      }

      var whereClause = []
      var j = 0
      for (let i = 0; i < filterParams.length; i++) {
        whereClause[j] = filterParams[i].join(' ')
        j++
      }
      this.inquiryParam.WhereClause = whereClause.join(' AND ')
      this.onSearch()
    },
    onResetFilter() {
      this.inquiryParam.WhereClause = ''
      this.searchParam.name = ''
      this.searchParam.first_name = ''
      this.searchParam.last_name = ''
      this.searchParam.email = ''

      this.searchParam.process_date_from = ''
      this.searchParam.process_date_to = ''
      this.searchParam.booking_date_from = ''
      this.searchParam.booking_date_to = ''

      this.$refs.processDateFrom._data.pickedValue = ''
      this.$refs.processDateTo._data.pickedValue = ''
      this.$refs.bookingDateFrom._data.pickedValue = ''
      this.$refs.bookingDateTo._data.pickedValue = ''

      this.searchParam.status = ''

      this.showBookingDateFrom = false
      this.$nextTick(() => {
        this.showBookingDateFrom = true
      })

      this.showBookingDateTo = false
      this.$nextTick(() => {
        this.showBookingDateTo = true
      })

      this.showProcessDateFrom = false
      this.$nextTick(() => {
        this.showProcessDateFrom = true
      })

      this.showProcessDateTo = false
      this.$nextTick(() => {
        this.showProcessDateTo = true
      })
    },

    onDownload() {
      this.inquiryParam.WhereClauseByProject = ''
      if (this.$store.state.userInfo.projects && this.$store.state.userInfo.projects.length > 0) {
        this.inquiryParam.WhereClauseByProject = 'project_id IN (' + this.$store.state.userInfo.projects.join() + ')'
        this.inquiryParam.WhereClauseByProject = this.inquiryParam.WhereClause === '' ? this.inquiryParam.WhereClauseByProject : this.inquiryParam.WhereClauseByProject + ' AND '
      }

      api
        .request('Payment', 'get', '/api/Payment/DownloadOrder?WhereClause=' + this.inquiryParam.WhereClauseByProject + this.inquiryParam.WhereClause +
                                 '&PageSize=9999999&CurrentPageNumber=1' +
                                 '&SortDirection=' + this.inquiryParam.SortDirection + '&SortExpression=' + this.inquiryParam.SortExpression, null, 'blob')
        .then(response => {
          const url = URL.createObjectURL(new Blob([response.data], {
            type: 'application/vnd.ms-excel'
          }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Orders.xls')
          document.body.appendChild(link)
          link.click()
        })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// PaymentOrder.vue?5bb0a48d